@ts-nocheck
<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-0">
      <div class="p-4">
        <div
          class="d-flex justify-content-between align-items-center flex-wrap gap-3"
        >
          <h3 class="mb-0">All Projects-</h3>
          <select
            class="form-select month-select form-control p-0 h-auto border-0 w-90"
            style="background-position: right 0 center"
            aria-label="Default select example"
          >
            <option selected>This Week</option>
            <option value="1">This Month</option>
            <option value="2">This Year</option>
          </select>
        </div>
      </div>

      <div class="default-table-area style-two all-projects">
        <div class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Project Name</th>
                <th scope="col">Client</th>
                <th scope="col">Assignees</th>
                <th scope="col">Budget</th>
                <th scope="col">Start Date</th>
                <th scope="col">End Date</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td class="text-body">
                  {{ item.id }}
                </td>
                <td>
                  <RouterLink to="/project-management/project-overview">
                    {{ item.projectName }}
                  </RouterLink>
                </td>
                <td>{{ item.client }}</td>
                <td>
                  <ul class="ps-0 mb-0 list-unstyled d-flex align-items-center">
                    <li
                      class="ms-m-15"
                      v-for="userImg in item.assignees.images"
                      :key="userImg.id"
                    >
                      <RouterLink to="/my-profile">
                        <img
                          :src="userImg.image"
                          class="wh-34 lh-34 rounded-circle border border-1 border-color-white"
                          alt="user"
                        />
                      </RouterLink>
                    </li>
                    <li class="ms-m-15">
                      <RouterLink
                        to="/users/users-list"
                        class="wh-34 lh-34 rounded-circle bg-primary d-block text-center text-decoration-none text-white fs-12 fw-medium border border-1 border-color-white"
                      >
                        {{ item.assignees.number }}
                      </RouterLink>
                    </li>
                  </ul>
                </td>
                <td class="text-body">${{ item.budget }}</td>
                <td class="text-body">
                  {{ item.startDate }}
                </td>
                <td class="text-body">
                  {{ item.endDate }}
                </td>
                <td>
                  <span
                    class="badge bg-opacity-10 p-2 fs-12 fw-normal"
                    :class="computeClass(item.status)"
                  >
                    {{ item.status }}
                  </span>
                </td>
                <td>
                  <div class="d-flex align-items-center gap-1">
                    <button
                      class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                    >
                      <i class="material-symbols-outlined fs-16 text-primary">
                        {{ item.action.view }}
                      </i>
                    </button>
                    <button
                      class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                    >
                      <i class="material-symbols-outlined fs-16 text-body">
                        {{ item.action.edit }}
                      </i>
                    </button>
                    <button
                      class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                    >
                      <i class="material-symbols-outlined fs-16 text-danger">
                        {{ item.action.delete }}
                      </i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="p-4 pt-lg-4">
<!--          <Pagination items="10" :total="items.length" />-->
          <Pagination items="10" total="100" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck
import { defineComponent, ref } from "vue";
import Pagination from "@/components/Common/Pagination.vue";
import axios from 'axios';

export default defineComponent({
  name: "ProjectsList",
  components: {
    Pagination,
  },
  data() {
    return {
      deleteAlert: {
        visible: false,
        row: null,
      },
      isOpen: false,
      isOpen2: false,
      vacancyDetail: null,
      isOffcanvasVisible: false,
      isMobile: false,
      userRole: '',
      user: '',
      tableKey: 0,
      managers: [],
      main_coordinators: [],
      coordinators: [],
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        // page: 1,
        // limit: 20,
        search: '',
        sort: '',
        is_active: '',
        is_confirmed: '',
      },
      sortOptions: [{label: 'ID Ascending', key: '+id'}, {label: 'ID Descending', key: '-id'}],
      statusOptions: ['published', 'draft', 'deleted'],
      showReviewer: false,
      candidatesToDelete: [],
      candidatesToHide: [],
      temp: {
        //managerId: null,
        //mainCoordinatorId: null,
        //coordinatorId: null,
        candidatesToDelete: [],
        candidatesToHide: [],
        title: '',
        isActive: true,
        gender: [],
        images: [],
        coordinatorPhone: '',
        candidates: [
          {
            isActive: '',
            position: '',
            rate: '',
            rateFrequency: 1,
            quantity1: '',
            quantity2: '',
            quantity3: '',
            age: '',
            nation: [],
            city: '',
            address: '',
            workShift: '',
            workShiftType: '',
            schedule1: '',
            schedule2: '',
            schedule3: '',
            livingExists: '',
            livingType: '',
            livingPrice: '',
            livingPlaces1: '',
            livingPlaces2: '',
            livingPlaces3: '',
            isArrival: '',
            arrivalAddress: '',
            arrivalPrice: '',
          }
        ]
      },
      dialogFormVisible: false,
      dialogFieldsVisible: false,
      dialogStatus: '',
      dialogPvVisible: false,
      fields: [
        {label: '№', name: 'number', showAsMain: true},
        {label: 'Вакансия', name: 'title', showAsMain: true},
        {label: 'Название', name: 'title', showAsDetails: true},
        {label: 'Город', name: 'city', showAsMain: true},
        {label: 'Кол.', name: 'quantity', showAsMain: true},
        {label: 'Должность', name: 'position', showAsMain: true, showAsDetails: true},
        {label: 'Ставка', name: 'rate', showAsMain: true, showAsDetails: true},
        {label: 'Жилье', name: 'livingExists', showAsMain: true},
        {label: 'Гражданство', name: 'nation', showAsMain: false},
        {label: 'Доезд', name: 'isArrival', showAsMain: false},
        {label: 'Требуются', name: 'gender', showAsMain: false},
        {label: 'Смены', name: 'schedule1'},
        {label: 'Возраст', name: 'age', showAsDetails: true},
        {label: 'График', name: 'schedule1', showAsDetails: true},
        {label: 'Смены', name: 'schedule2'},
        {label: 'Смены', name: 'schedule3'},
        {label: 'Пары', name: 'pairs', showAsMain: false},
        {label: 'Координатор', name: 'coordinatorId', showAsDetails: true},
        {label: 'Тел. коорд.', name: 'coordinatorPhone', showAsDetails: true},
        {label: 'Количество людей', name: 'quantity1'},
        {label: 'Цена жилья', name: 'livingPrice'},
        {label: 'Адрес жилья', name: 'living', showAsDetails: true},
        {label: 'Адрес', name: 'address', showAsDetails: true},
        {label: 'Смена', name: 'workShift'},
        {label: 'Тип смены', name: 'workShiftType'},
        {label: 'Описание', name: 'description'},
        {label: 'Комментарий', name: 'comment'},
        {label: 'Активная', name: 'isActive'},
        {label: 'Приоритет', name: 'isPriority'},
        {label: 'Для посредников', name: 'isMediator'},
        {label: 'Адрес доезда', name: 'arrivalAddress'},
        {label: 'Цена доезда', name: 'arrivalPrice'},
      ],
      //rules: this.setRules(),
      downloadLoading: false,
    };
 /*   return {
      items: [
       /!* {
          id: "#854",
          projectName: "Project CyberSphere",
          client: "NovaTech Solutions",
          assignees: {
            images: [
              {
                id: 1,
                image: require("@/assets/images/user-15.jpg"),
              },
              {
                id: 2,
                image: require("@/assets/images/user-11.jpg"),
              },
              {
                id: 3,
                image: require("@/assets/images/user-6.jpg"),
              },
              {
                id: 4,
                image: require("@/assets/images/user-9.jpg"),
              },
            ],
            number: "+10",
          },
          budget: "4,500",
          startDate: "25 Mar 2024",
          endDate: "25 Apr 2024",
          status: "Finished",
          action: {
            view: "visibility",
            edit: "edit",
            delete: "delete",
          },
        },
        {
          id: "#853",
          projectName: "Digital Oasis Initiative",
          client: "AlphaWave Innovations",
          assignees: {
            images: [
              {
                id: 1,
                image: require("@/assets/images/user-7.jpg"),
              },
              {
                id: 2,
                image: require("@/assets/images/user-8.jpg"),
              },
              {
                id: 3,
                image: require("@/assets/images/user-9.jpg"),
              },
            ],
            number: "+04",
          },
          budget: "6,800",
          startDate: "20 Mar 2024",
          endDate: "20 Apr 2024",
          status: "In Progress",
          action: {
            view: "visibility",
            edit: "edit",
            delete: "delete",
          },
        },*!/
      ],
    };*/
  },
  methods: {
    toggleSection(section) {
      this.openedSections[section] = !this.openedSections[section];
      // Save state to localStorage
      localStorage.setItem("sidebarState", JSON.stringify(this.openedSections));
    },
    menuItemToggle() {
      this.isOpen = !this.isOpen; // Toggles the `open` class
    },
    menuItemToggle2() {
      this.isOpen2 = !this.isOpen2; // Toggles the `open` class
    },
    showDetails(id) {
      this.vacancyDetail = id;
      this.isOffcanvasVisible = true;
    },
    closeOffcanvas() {
      this.isOffcanvasVisible = false;  // Close the offcanvas
    },
    checkScreenSize() {
      this.isMobile = window.matchMedia("(max-width: 767px)").matches;
      console.log(this.isMobile ? 'This is a mobile screen size.' : 'This is not a mobile screen size.');
    },
    getRowClass({row}) {
      //return row.isPriority ? 'priority-row' : 'priority-row1';
      return 'priority-row1';
    },
    updateMainCoordinators() {
      // Filter main_coordinators based on selected manager
      // const manager = this.managers.find(
      //   (m) => m.id === this.temp.managerId
      // );
      // this.main_coordinators = this.main_coordinators.filter(
      //   (c) => c.owner_id === (manager ? manager.id : null)
      // );

      // Reset dependent fields
      this.temp.mainCoordinatorId = null;
      this.temp.coordinatorId = null;
      //this.coordinators = [];
    },
    updateCoordinators() {
      // Filter coordinators based on selected main_coordinator
      // const mainCoordinator = this.main_coordinators.find(
      //   (mc) => mc.id === this.temp.mainCoordinatorId
      // );
      // this.coordinators = this.coordinators.filter(
      //   (c) => c.owner_id === (mainCoordinator ? mainCoordinator.id : null)
      // );

      // Reset dependent field
      this.temp.coordinatorId = null;
    },
    setCoordinatorPhone(e) {
      let coordFind = this.coordinators.find(u => u.id === e);
      this.temp.coordinatorPhone = coordFind.phone;
    },
    addCandidate() {
//
    },
    addCandidateRow() {
      this.temp.candidates.push(
          {
            isActive: '',
            position: '',
            rate: '',
            rateFrequency: 1,
            quantity1: '',
            quantity2: '',
            quantity3: '',
            age: '',
            nation: [],
            city: '',
            address: '',
            workShift: '',
            workShiftType: '',
            schedule1: '',
            schedule2: '',
            schedule3: '',
            livingExists: '',
            livingType: '',
            livingPrice: '',
            livingPlaces1: '',
            livingPlaces2: '',
            livingPlaces3: '',
            isArrival: '',
            arrivalAddress: '',
            arrivalPrice: '',
          }
      );
    },
    setCandidateStatus(candidate, status) {
      const index = this.temp.candidates.indexOf(candidate);
      if (index !== -1) {
        this.temp.candidates[index].isActive = status;
      } else {
        console.error("Candidate not found");
      }
    },
    deleteCandidateRow(candidate) {
      const index = this.temp.candidates.indexOf(candidate);
      if (index !== -1) {
        // If candidate has an ID, add it to the candidatesToDelete array
        if (candidate.id) {
          this.candidatesToDelete.push(candidate.id);
        }
        this.temp.candidates.splice(index, 1);  // Remove candidate from the list
      }
    },
    parseStatusFromUrl() {
      const path = this.$route.path;
      const regex = /status(\d+)/;
      const match = path.match(regex);

      if (path.includes('create')) {
        this.handleCreate();
        return;
      }

      if (path.includes('edit')) {
        const id = parseInt(path.split('/').pop());
        const item = this.list.find(item => item.id === id);
        if (item) {
          this.handleView(item, 'update');
        } else {
          console.error(`Item with ID ${id} not found in the list.`);
        }
        return;
      }
      if (match && match[1]) {
        if (parseInt(match[1]) === 1) {
          this.listQuery.is_active = 1;
          this.listQuery.is_confirmed = 1;
        } else if (parseInt(match[1]) === 0) {
          this.listQuery.is_active = 0;
          this.listQuery.is_confirmed = 1;
        } else if (parseInt(match[1]) === 2) {
          this.listQuery.is_active = 1;
          this.listQuery.is_confirmed = 0;
        }
      } else {
        this.listQuery.is_active = this.$route.query.status || null;
      }
    },
    setRules() {
      return {
        // number: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        title: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        //coordinatorId: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        //coordinatorPhone: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // position: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // rate: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // rateFrequency: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // rateUnit: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // schedule1: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // city: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // coordinatorId: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // gender: [{type: 'array', required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // //quantity: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // livingExists: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // age: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // address: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // coordinatorPhone: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // workShift: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // workShiftType: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        //isArrival: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        //description: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
      };
    },
    async getList() {
      this.listLoading = true;
      this.parseStatusFromUrl();
      const data = await fetchList(this.listQuery);
      if (data.redirect_to) {
        window.location.href = data.redirect_to;
      }
      this.list = data.vacancies.items.map(vacancy => {
        if (vacancy.vacancyCandidates && Array.isArray(vacancy.vacancyCandidates)) {
          // Add description_old for each vacancyCandidate
          vacancy.vacancyCandidates.forEach(candidate => {
            candidate.description_old = candidate.description;
          });
        }
        return vacancy;
      });

      //console.log(this.list);
      this.total = data.vacancies.total;
      this.userRole = data.userRole;

      this.managers = data.managers;
      this.main_coordinators = data.mainCoordinators;
      this.coordinators = data.coordinators;

      this.user = data.user;

      if (this.userRole === 'manager') {
        this.temp.managerId = this.user.id;
      }

      if (this.userRole === 'coordinator_main') {
        this.temp.mainCoordinatorId = this.user.id;
      }

      if (this.userRole === 'coordinator') {
        this.temp.coordinatorId = this.user.id;
        this.temp.coordinatorPhone = this.user.phone;
      }

      this.listLoading = false;
    },
    handleFilter() {
      const searchQuery = this.listQuery.search?.trim(); // Ensure search is trimmed and exists

      if (!searchQuery) {  // If searchQuery is null, undefined, or empty, reset the filter
        localStorage.removeItem('searchQuery');
        this.listQuery.search = '';
        this.listQuery.page = 1;
        this.getList();  // Return full list
      } else if (searchQuery.length === 1) {
        // Do nothing if length is 1
        return;
      } else if (searchQuery.length > 1) {  // If length > 1, search and save
        localStorage.setItem('searchQuery', searchQuery);
        this.listQuery.page = 1;
        this.getList();
      }
    },
    handleModifyStatus(row, status) {
      this.$message({
        message: 'Successful operation',
        type: 'success',
      });
      row.status = status;
    },
    sortChange(data) {
      const {prop, order} = data;
      this.sortBy(prop, order);
    },
    sortBy(prop, order) {
      if (order === 'ascending') {
        this.listQuery.sort = '+' + prop;
      } else {
        this.listQuery.sort = '-' + prop;
      }
      this.handleFilter();
    },
    resetTemp() {
      this.temp = {
        managerId: null,
        mainCoordinatorId: null,
        coordinatorId: null,
        candidatesToDelete: [],
        candidatesToHide: [],
        title: '',
        isActive: true,
        gender: [],
        images: [],
        coordinatorPhone: '',
        candidates: [
          {
            position: '',
            rate: '',
            rateFrequency: 1,
            quantity1: '',
            quantity2: '',
            quantity3: '',
            age: '',
            nation: [],
            city: '',
            address: '',
            workShift: '',
            workShiftType: '',
            schedule1: '',
            schedule2: '',
            schedule3: '',
            livingExists: '',
            livingType: '',
            livingPrice: '',
            livingPlaces1: '',
            livingPlaces2: '',
            livingPlaces3: '',
            isArrival: '',
            arrivalAddress: '',
            arrivalPrice: '',
          }
        ]
      };

      if (this.userRole === 'manager') {
        this.temp.managerId = this.user.id;
      }

      if (this.userRole === 'coordinator_main') {
        this.temp.mainCoordinatorId = this.user.id;
      }

      if (this.userRole === 'coordinator') {
        this.temp.coordinatorId = this.user.id;
        this.temp.coordinatorPhone = this.user.phone;
      }
    },
    handleCreate() {
      this.resetTemp();
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    formatErrors(errors) {
      let formattedErrors = '';
      for (const key in errors) {
        if (errors.hasOwnProperty(key)) {
          formattedErrors += `${errors[key].join(', ')}\n`;
        }
      }
      return formattedErrors;
    },
    formatServerError(response) {
      let formattedError = `Статус: ${response.status} ${response.statusText}\n`;
      if (response.data && response.data.message) {
        formattedError += `Сообщение: ${response.data.message}\n`;
      }
      if (response.data && response.data.errors) {
        formattedError += this.formatErrors(response.data.errors);
      }
      return formattedError;
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          createVacancy(this.temp)
              .then(() => {
                this.list.unshift(this.temp);
                this.dialogFormVisible = false;
                this.$notify({
                  title: 'Успешно',
                  message: 'Вакансия создана',
                  type: 'success',
                  duration: 2000,
                });
                window.location.reload();
              })
              .catch((error) => {
                let errorMessage = 'Произошла ошибка';
                if (error.response) {
                  if (error.response.status === 422) {
                    errorMessage = 'Ошибка валидации: ' + this.formatErrors(error.response.data.errors);
                  } else if (error.response.status === 500) {
                    errorMessage = 'Внутренняя ошибка сервера: ' + this.formatServerError(error.response);
                  } else {
                    errorMessage = `Ошибка: ${this.formatServerError(error.response)}`;
                  }
                } else {
                  errorMessage = 'Ошибка сети или сервер недоступен';
                }
                alert(errorMessage);
              });
        }
      });
    },
    handleRowRightClick(row, column, event) {
      if (this.userRole !== 'recruiter_su' && this.userRole !== 'recruiter_zl') {
        event.preventDefault();
        this.handleView(row, 'edit');
      }
    },
    handleView(row, mode) {
      console.log(row);

      // Deep clone the row object
      this.temp = JSON.parse(JSON.stringify(row));

      // Ensure reactivity by setting temp.candidates to a reactive array
      this.$set(this.temp, 'candidates', this.temp.vacancyCandidates.map(candidate => {
        // Parse nation field of each candidate
        let parsedCandidate = {
          ...candidate,
          nation: JSON.parse(candidate.nation)
        };
        return parsedCandidate;
      }));

      // Set dialog properties
      this.dialogStatus = mode;
      this.dialogFormVisible = true;

      // Clear validation
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.temp.candidatesToDelete = this.candidatesToDelete;
          this.temp.candidatesToHide = this.candidatesToHide;
          const tempData = Object.assign({}, this.temp);
          updateVacancy(tempData).then(() => {
            for (const v of this.list) {
              if (v.id === this.temp.id) {
                const index = this.list.indexOf(v);
                this.list.splice(index, 1, this.temp);
                break;
              }
            }
            this.dialogFormVisible = false;
            this.$notify({
              title: 'Успешно',
              message: 'Данные успешно изменены',
              type: 'success',
              duration: 2000,
            });
            window.location.reload();
          });
        }
      });
    },
    showDeleteConfirmation(row) {
      this.deleteAlert.row = row;
      this.deleteAlert.visible = true;
    },
    confirmDelete() {
      const row = this.deleteAlert.row;
      if (row) {
        deleteVacancy(row).then(() => {
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
          this.cancelDelete();
        });
      }
    },
    cancelDelete() {
      this.deleteAlert.visible = false;
      this.deleteAlert.row = null;
    },

    handleDelete(row) {
      /*  deleteVacancy(row).then(() => {
          this.$notify({
            title: 'Успешно',
            message: 'Удалено',
            type: 'success',
            duration: 2000,
          });
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
        });*/
    },
    handleImage(e) {
      const files = e.target.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => {
          this.temp.images.push(e.target.result);
        };
      }
    },
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    deleteImage(index) {
      this.temp.images.splice(index, 1);
    },
    openImageInNewTab(image) {
      const url = image.startsWith('http') ? image : `${window.location.origin}/${image}`;
      window.open(url, '_blank');
    },
    handleCopyField(field, row, living = null) {
      let textToCopy = '';
      switch (field.name) {
        case 'gender':
          textToCopy = '' + row.gender.join(', ');
          break;
        case 'schedule1':
          textToCopy = '' + row.schedule1;
          if (row.schedule2 && row.schedule2 !== 'null') {
            textToCopy += ', ' + row.schedule2;
          }
          if (row.schedule3 && row.schedule3 !== 'null') {
            textToCopy += ', ' + row.schedule3;
          }
          break;
        case 'coordinatorId':
          textToCopy = '' + (row.coordinator ? row.coordinator.name : '');
          break;
        case 'coordinatorPhone':
          textToCopy = '' + (row.coordinator ? row.coordinator.phone : '');
          break;
        case 'quantity1':
          textToCopy = '' + row.quantity1;
          break;
        case 'quantity2':
          textToCopy = '' + row.quantity2;
          break;
        case 'quantity3':
          textToCopy = '' + row.quantity3;
          break;
        case 'living':
          textToCopy = '' + living
          break;
        case 'livingExists':
          textToCopy = '' + (row.livingExists === 0 ? 'No' : 'Yes');
          break;
        default:
          textToCopy = row[field.name];
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
              console.log('Text copied to clipboard: ', textToCopy);
            })
            .catch(err => {
              console.error('Failed to copy text: ', err);
            });
      } else {
        // Fallback method
        const textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          const successful = document.execCommand('copy');
          if (successful) {
            console.log('Text copied to clipboard: ', textToCopy);
          } else {
            console.error('Failed to copy text');
          }
        } catch (err) {
          console.error('Failed to copy text: ', err);
        }
        document.body.removeChild(textArea);
      }
    },
    handleCopyText(row, vacancy) {
      let scheduleText = row.schedule1;
      if (row.schedule2 && row.schedule2 !== 'null') {
        scheduleText += ' ' + row.schedule2;
      }
      if (row.schedule3 && row.schedule3 !== 'null') {
        scheduleText += ' ' + row.schedule3;
      }

      const textToCopy =
          'Название: ' + vacancy + '\n\n' +
          'Должность: ' + row.position + '\n\n' +
          'Cтавка: ' + row.rate + '\n\n' +
          'Возраст: ' + row.age + '\n\n' +
          'График: ' + scheduleText + '\n\n' +
          'Описание: ' + row.description;

      const textArea = document.createElement('textarea');
      textArea.value = textToCopy;
      document.body.appendChild(textArea);
      //textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          console.log('Text copied to clipboard');
        } else {
          console.error('Failed to copy text');
        }
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }

      document.body.removeChild(textArea);
    },
    handleCopy(data) {
      this.resetTemp();
      this.temp = data
      this.temp.id = null;
      this.temp.images = [];
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    toggleRowExpansion(row) {
      this.$refs.elTable.toggleRowExpansion(row);
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
         // return parseTime(v[j]);
          return v[j];
        } else {
          return v[j];
        }
      }));
    },
  },
  setup() {
    const wordConfirmed = ref("Finished");
    const wordInProgress = ref("In Progress");
    const wordPending = ref("Pending");

    const computeClass = (classValue: string) => {
      return {
        confirmed: wordConfirmed.value === classValue,
        inProgress: wordInProgress.value === classValue,
        pending: wordPending.value === classValue,
      };
    };

    return {
      computeClass,
    };
  },
  async mounted() {
    try {
      const response = await axios.get('http://194.182.78.173/candidates');
      //this.items = response.data; // Update data with fetched response
    } catch (error) {
      console.error('Error fetching data:', error);
      // Handle errors gracefully (e.g., display an error message)
    }
  },
});
</script>

<style lang="scss" scoped>
.default-table-area {
  .table-responsive {
    .table {
      tbody {
        tr {
          td {
            ul {
              li {
                &.ms-m-15 {
                  &:first-child {
                    margin-left: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
